import React from 'react'

import { Loading } from '../../root/components/common'
import { MoveHistoryTable } from './move-history-table'

export function DeviceMoveHistory({ device }) {
    return (
        <div>{device ? <MoveHistoryTable device={device} /> : <Loading />}</div>
    )
}
